// @ts-check
import React from 'react';
import 'Styles/commonComponents/Popup2.scss';

/**
 * @param {{
 *  children: React.JSX.Element | React.JSX.Element[],
 *  popupText: string,
 *  isTop: boolean,
 *  textAlignIsLeft: boolean,
 *  widthPx: number,
 *  moveLeftFromIconPx: number,
 * }} props 
 * @returns {React.JSX.Element}
 */
const Popup2 = (props) => {

    let moveLeftFromIconPx = props.moveLeftFromIconPx > 0 ? props.moveLeftFromIconPx : 0;
    let widthPx = props.widthPx > 0 ? props.widthPx : 0;
    let isTop = props.isTop;
    let textAlignIsLeft = props.textAlignIsLeft;

    let popupLeftPx = -10 - moveLeftFromIconPx;
    let popupArrowLeftPx = 2 + moveLeftFromIconPx;

    return (
        <div
            className={"popup2-inside"}>
            {props.children}
            <div
                className={"popup2 " + (isTop ? "popup2-top" : "popup2-bottom")}
                style={{
                    left: `${popupLeftPx}px`,
                    width: widthPx > 0 ? `${widthPx}px` : undefined
                }}>
                <div className="popup2-text" style={{ textAlign: (textAlignIsLeft ? "left" : "center") }}>
                    {props.popupText}
                </div>
                <div
                    className={"popup2-arrow " + (isTop ? "popup2-top-arrow" : "popup2-bottom-arrow")}
                    style={{ left: `${popupArrowLeftPx}px` }}>
                </div>
            </div>
        </div>
    );
}

export default Popup2;